import React from "react";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import IconExpandMore from "@mui/icons-material/ExpandMore";
import IconExpandLess from "@mui/icons-material/ExpandLess";

const StyledList = styled(List)({
  width: "100%",
  cursor:'pointer'
});

const StyledListItem = styled(ListItem)(({ theme, selected }) => ({
  padding: theme.spacing(1),
  backgroundColor: selected ? "#1F36C7" : "inherit",
  color: selected ? "#FFFFFF" : "#2B2B2B",
  "&:hover": {
    backgroundColor: "#1F36C7",
    color: "#FFFFFF",
  },
}));

const StyledListItemText = styled(ListItemText)({
  paddingLeft: "15px",
  fontSize: "12px !important",
  margin: 0,
});

const StyledListItemTextHeader = styled(ListItemText)({
  fontSize: "14px !important",
  margin: 0,
});

const InsightMenu = ({ sections, onNavigate, selectedItem, onToggleSection }) => {
  return (
    <StyledList component="nav">
      {sections.map((section, sectionIndex) => (
        <React.Fragment key={section.title}>
          <StyledListItem button onClick={() => onToggleSection(sectionIndex)}>
            <StyledListItemTextHeader primary={section.title} sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} />
            {section.isOpen ? <IconExpandLess sx={{ "& .MuiSvgIcon-root": { fontSize: "16px" } }} /> : <IconExpandMore sx={{ "& .MuiSvgIcon-root": { fontSize: "16px" } }} />}
          </StyledListItem>
          <Collapse in={section.isOpen} timeout="auto" unmountOnExit>
            {section.items.map((item) => (
              <StyledListItem
                button
                key={item}
                selected={selectedItem === item}
                onClick={() => onNavigate(item)}
                sx={{ "& .MuiTypography-root": { fontSize: "12px" } }}
              >
                <StyledListItemText primary={item} />
              </StyledListItem>
            ))}
          </Collapse>
        </React.Fragment>
      ))}
    </StyledList>
  );
};

export default InsightMenu;